/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Mvp_Sprint_Architect_Output9Inputs */

const en_svc_mvp_sprint_architect_output9 = /** @type {(inputs: Svc_Mvp_Sprint_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clickable skeleton`)
};

const ar_svc_mvp_sprint_architect_output9 = /** @type {(inputs: Svc_Mvp_Sprint_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هيكل قابل للنقر`)
};

const bn_svc_mvp_sprint_architect_output9 = /** @type {(inputs: Svc_Mvp_Sprint_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ক্লিকযোগ্য কঙ্কাল`)
};

const de_svc_mvp_sprint_architect_output9 = /** @type {(inputs: Svc_Mvp_Sprint_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klickbares Skelett`)
};

const es_svc_mvp_sprint_architect_output9 = /** @type {(inputs: Svc_Mvp_Sprint_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esqueleto navegable`)
};

const fr_svc_mvp_sprint_architect_output9 = /** @type {(inputs: Svc_Mvp_Sprint_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Squelette cliquable`)
};

const pt_svc_mvp_sprint_architect_output9 = /** @type {(inputs: Svc_Mvp_Sprint_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esqueleto navegável`)
};

const zh_svc_mvp_sprint_architect_output9 = /** @type {(inputs: Svc_Mvp_Sprint_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可点击原型`)
};

const tr_svc_mvp_sprint_architect_output9 = /** @type {(inputs: Svc_Mvp_Sprint_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tıklanabilir iskelet`)
};

const ru_svc_mvp_sprint_architect_output9 = /** @type {(inputs: Svc_Mvp_Sprint_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Кликабельный скелет`)
};

const pl_svc_mvp_sprint_architect_output9 = /** @type {(inputs: Svc_Mvp_Sprint_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klikalny szkielet`)
};

/**
* | output |
* | --- |
* | "Clickable skeleton" |
*
* @param {Svc_Mvp_Sprint_Architect_Output9Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_mvp_sprint_architect_output9 = /** @type {((inputs?: Svc_Mvp_Sprint_Architect_Output9Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Mvp_Sprint_Architect_Output9Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_mvp_sprint_architect_output9(inputs)
	if (locale === "bn") return bn_svc_mvp_sprint_architect_output9(inputs)
	if (locale === "de") return de_svc_mvp_sprint_architect_output9(inputs)
	if (locale === "es") return es_svc_mvp_sprint_architect_output9(inputs)
	if (locale === "fr") return fr_svc_mvp_sprint_architect_output9(inputs)
	if (locale === "pt") return pt_svc_mvp_sprint_architect_output9(inputs)
	if (locale === "zh") return zh_svc_mvp_sprint_architect_output9(inputs)
	if (locale === "tr") return tr_svc_mvp_sprint_architect_output9(inputs)
	if (locale === "ru") return ru_svc_mvp_sprint_architect_output9(inputs)
	if (locale === "pl") return pl_svc_mvp_sprint_architect_output9(inputs)
	return en_svc_mvp_sprint_architect_output9(inputs)
});
export { svc_mvp_sprint_architect_output9 as "svc_mvp-sprint_ARCHITECT_output" }